import React from 'react';

const SvgStopwatch: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g strokeLinecap="round" strokeLinejoin="round">
        <path d="M10 2h4M17.657 7.343A8 8 0 116.343 18.657 8 8 0 0117.657 7.343" />
        <path d="M11.999 8a.244.244 0 10.001.489A.244.244 0 0012 8M11.999 17.512a.244.244 0 10.001.489.244.244 0 00-.001-.489M17 12.999a.244.244 0 10-.489.001A.244.244 0 0017 13M7.488 12.999a.244.244 0 10-.489.001.244.244 0 00.489-.001M15.535 9.464a.244.244 0 10.001.346.245.245 0 00-.001-.346M8.809 16.19a.244.244 0 10.001.346.245.245 0 00-.001-.346M15.536 16.535a.244.244 0 10-.346.001c.096.095.25.095.346-.001M8.81 9.809a.244.244 0 10-.346.001c.095.095.25.095.346-.001" />
      </g>
    </svg>
  );
};

export default SvgStopwatch;
